import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { createEnvelope, updateEnvelope } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import { CustomDatePicker } from "../../../../components";
import { DATE_FORMAT_LIST } from "../../../../configs/AppConfig";
import Select from 'react-select';
import "../../../../assets/css/sleeve.css";

function EnvelopeStep1(props) {
    const navigate = useNavigate();
    const [pastDate, setPastDate] = useState(new Date());
    const [senderList, setSenderList] = useState([]);
    const [envelopeSenderId, setEnvelopeSenderId] = useState(0);
    const [envelopeName, setEnvelopeName] = useState('');
    const [envelopeDate, setEnvelopeDate] = useState('');
    const [clientMessage, setClientMessage] = useState('');

    const dueDateRef = useRef(null);

    let errorsObj = {
        sender_id: '',
        envelope_name: '',
        envelope_date: '',
        client_message: '',
    };
    const [errors, setErrors] = useState(errorsObj);


    function getInitials(firstName, lastName) {
        if (!firstName && !lastName) return '';
        return ((firstName ? firstName[0] : '') + (lastName ? lastName[0] : '')).toUpperCase();
    }

    const removeBackdrop = () => {
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop) {
            backdrop.remove();
            document.body.style.overflow = 'auto';
        }
    };

    const observer = new MutationObserver(() => {
        const offcanvas = document.querySelector('.offcanvas.show');
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop && !offcanvas) {
            removeBackdrop();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });


    useEffect(() => {

        setPastDate(Utils.pastDate());

        if (props?.senderList.length > 0) {
            setSenderList(props.senderList);
        }
        setEnvelopeSenderId((props.formObj.sender_id) ? props.formObj.sender_id : 0);

        if (!props.formObj.sender_id) {
            let index = props?.senderList.findIndex(x => x.is_login_user === true);
            if (index > -1) {
                setEnvelopeSenderId(props.senderList[index]['id']);
            }
        }

        setEnvelopeName((props.formObj.envelope_name) ? props.formObj.envelope_name : '');
        setEnvelopeDate((props.formObj.envelope_date) ? props.formObj.envelope_date : '');
        setClientMessage((props.formObj.client_message) ? props.formObj.client_message : '');
    }, [props]);

    function onBack(e) {
        e.preventDefault();
        navigate('/client-portal');
    }

    function onSaveExit(e) {
        e.preventDefault();
        onSubmitForm(1);
    }

    function onNext(e) {
        e.preventDefault();
        onSubmitForm(2);
    }

    function onSubmitForm(type) {
        let error = false;
        const errorObj = { ...errorsObj };
        if (!envelopeSenderId) {
            errorObj.sender_id = 'Please select sender';
            error = true;
        }
        if (!envelopeName) {
            errorObj.envelope_name = 'Sleeves name must be required';
            error = true;
        }
        if (!envelopeDate) {
            errorObj.envelope_date = 'Please select date';
            error = true;
        }
        if (!clientMessage) {
            errorObj.client_message = 'Please enter message';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        const formData = { ...props.formObj };

        let obj = {
            sender_id: envelopeSenderId,
            envelope_name: envelopeName,
            due_date: envelopeDate,
            message: clientMessage
        };

        props.setLoading(true);
        if (formData.envelope_id > 0) {
            obj['envelope_id'] = formData.envelope_id;
            updateEnvelope(obj)
                .then(response => {
                    if (type === 2) {
                        formData.current_step = 2;
                        formData.sender_id = envelopeSenderId;
                        formData.envelope_name = envelopeName;
                        formData.envelope_date = envelopeDate;
                        formData.client_message = clientMessage;
                        props.setFormObj(formData);
                        navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/2');
                    } else {
                        navigate('/manage/draft');
                    }
                    toast.success(response.data.message);
                    props.setLoading(false);
                })
                .catch(err => {
                    toast.error(Utils.getErrorMessage(err));
                    props.setLoading(false);
                });
        } else {
            obj['send_reminder'] = formData.send_reminder;
            obj['over_due_reminder'] = formData.over_due_reminder;
            createEnvelope(obj)
                .then(response => {
                    if (type === 2) {
                        formData.envelope_id = response.data.id;
                        formData.envelope_uuid = response.data.uuid;
                        formData.current_step = 2;
                        formData.sender_id = envelopeSenderId;
                        formData.envelope_name = envelopeName;
                        formData.envelope_date = envelopeDate;
                        formData.client_message = clientMessage;
                        props.setFormObj(formData);
                        navigate('/client-portal/sleeve/edit/' + response.data.uuid + '/2');
                    } else {
                        navigate('/client-portal');
                    }
                    toast.success(response.data.message);
                    props.setLoading(false);
                })
                .catch(err => {
                    toast.error(Utils.getErrorMessage(err));
                    props.setLoading(false);
                });
        }
    }

    useEffect(() => {
        console.log("Body Class List in StepX:", document.body.classList);
    }, []);

    const showDate = (date) => {
        let dateFormat = '';
        if (date) {
            dateFormat = new Date(date);
        }
        return dateFormat;
    };

    const senderOptions = senderList.map(item => ({
        value: Number(item.id),
        label: `${item.first_name} ${item.last_name} (${item.email})`,
        data: item,
    }));
    const selectedSenderOption = senderOptions.find(opt => opt.value === Number(envelopeSenderId)) || null;


    return (
        <div className="sleeve-gradient-bg sleeve-step">
            <div className="sleeve-main-card">

                {/* Custom Header */}
                <div className="sleeve-contract-setup-header">
                    <div className="sleeve-contract-setup-header-content">
                        <div>
                            <div className="sleeve-contract-title">Contract Setup</div>
                            <div className="sleeve-contract-subtitle">Let's get the basics down.</div>
                        </div>
                        <div className="text-end">
                            <div className="sleeve-step-indicator-custom">Step 1 of 4</div>
                        </div>
                    </div>
                </div>

                {/* Sender Section */}
                <div className="sleeve-sender-card mb-4">
                    <h2 className="sleeve-heading mb-2">
                        {/* <i className="bi bi-person" /> */}
                        <span>
                            Your Email Address (Sender)
                            <i
                                className="bi bi-info-circle ms-1 text-muted cursor-pointer fs-6"
                                aria-hidden="true"
                                data-toggle="tooltip"
                                data-placement="left"
                                title="The selected email address will be used to execute the contract signature. Please select from your verified addresses."
                            />
                        </span>
                    </h2>
                    <Select
                        classNamePrefix="sleeve-sender-select"
                        value={selectedSenderOption}
                        onChange={(option) =>
                            setEnvelopeSenderId(option ? Number(option.value) : 0)
                        }
                        options={senderOptions}
                        placeholder="Select sender"
                        isSearchable={false}
                        formatOptionLabel={(option) => (
                            <div className="sleeve-sender-option">
                                <div className="sleeve-sender-initials">
                                    {getInitials(option.data.first_name, option.data.last_name)}
                                </div>
                                <div>
                                    <div className="sleeve-sender-name">
                                        {option.data.first_name} {option.data.last_name}
                                    </div>
                                    <div className="sleeve-sender-email">
                                        {option.data.email}
                                    </div>
                                </div>
                            </div>
                        )}
                        styles={{
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected || state.isFocused ? '#e0e0e0' : 'white',
                                color: 'black',
                                cursor: 'pointer',
                                ':active': {
                                    backgroundColor: '#c0c0c0',
                                },
                            }),
                        }}
                    />
                    {errors.sender_id && (
                        <div className="error-message">{errors.sender_id}</div>
                    )}
                </div>

                {/* Form Section */}
                <div className="sleeve-sender-card mb-4">
                    <div className="row g-3">
                        {/* Sleeves Name */}
                        <div className="col-lg-7">
                            <label className="sleeve-step-label mb-2">
                                Request Title (Contract Sleeve Name)
                                <i
                                    className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                                    aria-hidden="true"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    title={'Give this contract a name so you can easily identify it later. Example: “IT Returns 2025” or “Loan Docs – March”."'}
                                />
                            </label>
                            <input
                                type="text"
                                className={`sleeve-step-input ${errors.envelope_name ? "input-error" : ""
                                    }`}
                                placeholder="Enter contract sleeve name"
                                value={envelopeName}
                                onChange={(e) => setEnvelopeName(e.target.value)}
                            />
                            {errors.envelope_name && (
                                <div className="input-error-message">
                                    {errors.envelope_name}
                                </div>
                            )}
                        </div>

                        <div className="col-lg-5">
                            <label className="sleeve-step-label mb-2">
                                Submission Deadline (Due Date)
                                <i
                                    className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                                    aria-hidden="true"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    title="Set a date by which the collaborator should sign the contract. This is optional, but helps set clear expectations."
                                />
                            </label>
                            
                            <CustomDatePicker
                                ref={dueDateRef}
                                selected={showDate(envelopeDate)}
                                onChange={(date) => setEnvelopeDate(date)}
                                minDate={pastDate}
                                placeholder="dd-mm-yyyy"
                                error={errors.envelope_date}
                            />
                        </div>
                    </div>
                </div>
                <div className="sleeve-sender-card mb-4">
                    <div className="">
                        <label className="sleeve-step-label mb-2">
                            Custom Message to Collaborators (Client Portal Message)
                            <i
                                className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                                aria-hidden="true"
                                data-toggle="tooltip"
                                data-placement="right"
                                title="This message will be visible to the collaborator. Please provide details regarding the contract and include any specific instructions related to its execution or signature."
                            />
                        </label>
                        <textarea
                            className="sleeve-step-textarea"
                            rows={10}
                            value={clientMessage}
                            onChange={(e) => setClientMessage(e.target.value)}
                            placeholder="Enter your message"
                        />
                        {errors.client_message && (
                            <div className="error-message">{errors.client_message}</div>
                        )}
                    </div>
                </div>
                {/* Buttons */}
                <div className="sleeve-step-buttons">
                    <div>
                        <button className="sleeve-btn-back" onClick={onBack}>
                            Back
                        </button>
                    </div>
                    <div className="sleeve-step-buttons-right">
                        <button className="sleeve-btn-save" onClick={onSaveExit}>
                            Save & Exit
                        </button>
                        <button className="sleeve-btn-next" onClick={onNext}>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnvelopeStep1;